const IS_BROWSER: boolean = typeof window === 'object';

export default IS_BROWSER;
